import { Head, useForm } from "@inertiajs/react"

import LocationSelect from "@/components/location-select"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import type RequestsSetupScoutProfile from "@/types/serializers/RequestsSetupScoutProfile"

export default function ScoutSetup() {
  const { data, setData, post, processing, errors } =
    useForm<RequestsSetupScoutProfile>({
      scout_profile: {
        organization_name: "",
        role_title: "",
        bio: "",
        country: "",
        region: "",
      },
    })

  const setField = (field: keyof typeof data.scout_profile, value: string) =>
    setData("scout_profile", { ...data.scout_profile, [field]: value })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/onboarding/scout_setup")
  }

  return (
    <>
      <Head title="Completar perfil de Scout" />

      <div className="bg-background flex min-h-svh flex-col items-center p-6">
        <img
          src="/images/krown_logo_header.png"
          alt="KrownFT"
          className="mb-6 h-10"
        />

        <div className="w-full max-w-lg">
          <div className="mb-6 text-center">
            <h1 className="text-xl font-semibold text-white">
              Completar perfil de Scout
            </h1>
            <p className="text-krown-50/70 mt-1 text-sm">
              Completá tu información para empezar a descubrir jugadores
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="bg-card space-y-4 rounded-lg p-6 shadow-lg"
          >
            <div className="space-y-1.5">
              <Label htmlFor="organization_name">Organización / Agencia</Label>
              <Input
                id="organization_name"
                value={data.scout_profile.organization_name}
                onChange={(e) => setField("organization_name", e.target.value)}
                placeholder="Ej: Talent Sports Agency"
              />
              {errors["scout_profile.organization_name"] && (
                <p className="mt-1 text-sm text-red-500">
                  {errors["scout_profile.organization_name"]}
                </p>
              )}
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="role_title">Cargo / Rol</Label>
              <Input
                id="role_title"
                value={data.scout_profile.role_title}
                onChange={(e) => setField("role_title", e.target.value)}
                placeholder="Ej: Scout Principal"
              />
              {errors["scout_profile.role_title"] && (
                <p className="mt-1 text-sm text-red-500">
                  {errors["scout_profile.role_title"]}
                </p>
              )}
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="bio">Bio</Label>
              <Textarea
                id="bio"
                value={data.scout_profile.bio ?? ""}
                onChange={(e) => setField("bio", e.target.value)}
                placeholder="Contá un poco sobre tu experiencia..."
                maxLength={500}
                rows={4}
              />
              <p className="mt-1 text-right text-xs text-neutral-500">
                {(data.scout_profile.bio ?? "").length}/500
              </p>
            </div>

            <LocationSelect
              country={data.scout_profile.country}
              region={data.scout_profile.region ?? ""}
              onCountryChange={(v) =>
                setData("scout_profile", {
                  ...data.scout_profile,
                  country: v,
                  region: "",
                })
              }
              onRegionChange={(v) => setField("region", v)}
              errors={{ country: errors["scout_profile.country"]?.[0] }}
              showCity={false}
            />

            <div className="pt-2">
              <Button
                type="submit"
                disabled={processing}
                className="bg-krown-accent text-krown-800 hover:bg-krown-accent/90 w-full"
              >
                Completar perfil
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
